import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectGrowthPointsParams } from '@/shared/api/end-points/project'
import { GrowthPointDto, growthPointMappers } from '../../lib'

const getGrowthPoints = async (params: GetProjectGrowthPointsParams) => {
  const res = await api.json<GrowthPointDto[]>(API_END_POINTS.project.getProjectGrowthPoints(params))

  if (res.ok) return (res.result || []).map((item) => growthPointMappers.mapGrowthPoint(item))
  if (!res.ok) throw new Error(res?.message || res?.error)
}

export default getGrowthPoints
